import { defineMessages } from 'react-intl';
import { ACTION_TYPE_INSURE_PACKAGE } from '../../../../../constants/action-types';
import { propertyForUpdateByActionType } from '../property-for-update-by-action-type';
import { selectAvailableInsuranceOptions } from '../../../../../../../../services/insurance-service';
import { US } from '../../../../../../../../constants/country-codes';
import Global from '../../../../../../../../store/global-selectors';
import { InsuranceProviders } from '../../../../../../../../enums/insurance-providers';
import { useEnableCarrierInsuranceBanner } from '../../../../../../../../feature-flags/hooks/use-enable-carrier-insurance-banner';
import { useDisableAutomationRuleInsureCarrier } from '../../../../../../../../feature-flags/hooks/use-disable-automation-rule-insure-carrier';

const propertyForUpdate = propertyForUpdateByActionType(ACTION_TYPE_INSURE_PACKAGE);

const messages = defineMessages({
  carrier: {
    description: 'insurance.carrier.endingsupport',
    defaultMessage: 'Carrier (Support Ending Soon)',
    id: 'EaP5nX',
  },
  carrierUnsupported: {
    description: 'insurance.carrier.unsupported',
    defaultMessage: 'Carrier (Unsupported)',
    id: 'Ip6MIa',
  },
});

const InsuranceOptions = (state) => {
  const homeCountry = Global.selectSellerHomeCountry(state);
  const wallets = Global.selectSellerWallets(state);
  const hasWalletConfigured = wallets && wallets.length > 0;
  const enableCarrierInsuranceBanner = useEnableCarrierInsuranceBanner();
  const disableAutomationRuleInsureCarrier = useDisableAutomationRuleInsureCarrier();

  return selectAvailableInsuranceOptions({ state }).map(({ insuranceOptionId, messageDescriptor }) => {
    const isCarrierOption = insuranceOptionId === InsuranceProviders.Carrier.insuranceProviderId;
    const shouldUseEndingSupportMessage = enableCarrierInsuranceBanner && isCarrierOption && homeCountry === US && hasWalletConfigured;
    const shouldUseUnsupportedMessage = disableAutomationRuleInsureCarrier && isCarrierOption && homeCountry === US && hasWalletConfigured;

    const shouldDisableCarrier = disableAutomationRuleInsureCarrier && isCarrierOption && homeCountry === US && hasWalletConfigured;

    let finalMessageDescriptor = messageDescriptor;
    if (shouldUseUnsupportedMessage) {
      finalMessageDescriptor = messages.carrierUnsupported;
    } else if (shouldUseEndingSupportMessage) {
      finalMessageDescriptor = messages.carrier;
    }

    return {
      [propertyForUpdate]: Number.parseInt(insuranceOptionId, 10),
      messageDescriptor: finalMessageDescriptor,
      disabled: shouldDisableCarrier,
    };
  });
};

export default InsuranceOptions;
